import { render } from "./modal-prompt.vue?vue&type=template&id=7b386c2f&ts=true"
import script from "./modal-prompt.vue?vue&type=script&lang=ts"
export * from "./modal-prompt.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__